<template>
	<v-card 
		class="mx-auto"
		max-width="600"
		flat
	>
		<v-app-bar flat color="transparent">
			<v-btn v-if="step > 0" icon @click="$emit('previous')">
            	<v-icon>mdi-arrow-left</v-icon>
            </v-btn>

			<v-toolbar-title class="text-h6">
				{{ title }}
			</v-toolbar-title>

			<!-- <v-spacer></v-spacer> -->
		</v-app-bar>
		<v-card-text>
			{{ text }}
		</v-card-text>
		<v-card-text>
			<v-form ref="form">
				<v-row>
					<v-col cols="12">
						<v-text-field
							label="Одометр"
							v-model.number.trim="item.odometer.value"
							outlined
							rounded
							clearable
							hide-details="auto"
							type="number"
							hide-spin-buttons
							@keyup.ctrl.90="setDefault"
						></v-text-field>
						<!-- :rules="[rules.required]" -->
					</v-col>
					<v-col cols="12">
						<z-photo
							v-model="item.odometer.photo"
						></z-photo>
					</v-col>
					
				</v-row>
			</v-form>
		</v-card-text>

		<v-card-actions>
			<v-spacer></v-spacer>
				<v-btn
					color="indigo"
					dark
					rounded
					block
					@click="onNext"
				>
					Далі
				</v-btn>
			<v-spacer></v-spacer>
		</v-card-actions>
	</v-card>
</template>

<script>
import mixin from './mixin/main'
import zPhoto from '@/views/components/picture/photo'

export default {
	name: 'VehicleOdometer',
	mixins: [mixin],
	components: {
		zPhoto,
	},
	props: {
		code:				{ type: String },
		title:				{ type: String, default: "Одометр" },
		text:				{ type: String, default: "Показання одометра (тахографа) транспортного засобу або лічильника мотогодин (за наявності)" },
		defaultValue:		{ type: String, default: '123456789'},
	},

	methods: {

		onNext(){
			//if (this.$refs.form.validate()) {
				this.$emit('next')
			//}
		},

		setDefault(){
			//this.item.number = this.defaultNumber
			this.$set(this.item,'number', this.defaultNumber)
		},
	},
}
</script>
